export const SET_DEVICES_LOADING = 'SET_DEVICES_LOADING'
export const SET_DEVICES = 'SET_DEVICES'
export const ADD_DEVICES = 'ADD_DEVICES'
export const EDIT_DEVICES = 'EDIT_DEVICES'
export const DELETE_DEVICES = 'DELETE_DEVICES'